import debug from 'bows';
const log = debug('layout:portfolio');

class Portfolio {
	constructor() {
		log(this);
	}
}

export default Portfolio;
